import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '@shared/services';

@Component({
    selector: 'app-bug-report',
    templateUrl: './bug-report.component.html',
    styleUrls: ['./bug-report.component.scss'],
    standalone: false
})
export class BugReportComponent implements OnInit {
    bugReportForm: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private bugReportDialogRef: MatDialogRef<BugReportComponent>,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.bugReportForm = this.fb.group({
            title: ['', Validators.required],
            text: ['Page: ' + window.location.href], // if only the route is needed, use this.router.url instead
            priority: ['lowPriority'],
            reporter: ['']
        });

        const getUserName = async () => {
            const userName = await this.userService.getMyUser().then(x => x.userData.fullName);
            this.bugReportForm.patchValue({ reporter: userName });
            document.getElementById('reporter').setAttribute('size', String(userName.length));
        };

        getUserName();
    }

    onSubmit(): void {
        if (!this.checkValidity()) {
            return;
        }
        console.warn(this.bugReportForm.value);
        this.bugReportDialogRef.close(`${this.bugReportForm.value.title}`);
    }

    checkValidity(): boolean {
        if (this.bugReportForm.invalid) {
            document.getElementById('bugTitleBox').classList.add('invalidTitle');
            return false;
        }
        document.getElementById('bugTitleBox').classList.remove('invalidTitle');
        return true;
    }
}
